import React from 'react';
import { Price, RegularButton, Typography } from 'fronton-react';
import { PriceBlock } from './styles';

type TProps = {
  priceMin: number | undefined;
  serviceURL: string;
  serviceName: string;
  onClickCallMaster?: () => void;
};

export const MeasurementBanner = ({ priceMin, serviceURL, serviceName, onClickCallMaster }: TProps) => {
  const handleClickCallMaster = () => {
    onClickCallMaster?.();
    window.open(serviceURL, '_blank', 'noopener noreferrer');
  };

  const price = typeof priceMin === 'number' ? priceMin : 0;

  return (
    <>
      <Typography variant="s" color="text-primary" size="body_long" data-testid="service-name-title">
        {serviceName}
      </Typography>
      <PriceBlock>
        <Typography size="body_long" variant="l">
          от
        </Typography>
        <Price fraction size="l" value={price} variant="regular" data-testid="min-price" />
      </PriceBlock>

      <RegularButton
        data-testid="call-master-button"
        invert
        variant="primary"
        onClick={handleClickCallMaster}>
        Вызвать мастера
      </RegularButton>
    </>
  );
};
